export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'EventConfiguration';
export const NAME = 'EventConfiguration';
